module.exports = __webpack_public_path__ + "img/1234653798.fc14851d.jpg";